export default __webpack_public_path__ + "static/media/time_display.7ece9dbc.png";